<div
  class="border-radius-200 vflex-100 pad-000 overflow-hidden"
  [class.bam-content]="data.isBAM"
  [class.full-page-dialog-content]="data.isFullPage"
  [class.spotlight-dialog-content]="data.isSpotlight"
  [class.preview-dialog-content]="data.isPreview"
  [class.surface-elevated]="!data.isSpotlight && !data.isPreview"
>
  <div
    class="vflex-000 dialog-content fill-height"
    [class.vpad-200]="!data.isSpotlight && !data.isPreview"
  >
    @if (showHeader()) {
      <div
        class="fill-width header-container"
        [class.has-border]="showHeaderBorder()"
        [class.hpad-300]="!data.isBAM && !data.isSpotlight && !data.isPreview"
        [class.hpad-400]="data.isBAM && !data.isSpotlight && !data.isPreview"
      >
        <mdw-dialog-header
          class="block"
          [mainTitle]="data.title || mainTitle()"
          [subtitle]="data.subTitle || subTitle()"
          [icon]="icon()"
          [rightContent]="rightHeaderConent()"
          [showCloseButton]="
            data.allowDismiss || !!data.isBAM || !!data.isFullPage || !!showCloseButton()
          "
          (closed)="complete(false)"
        ></mdw-dialog-header>
      </div>
    }

    @let hasCustomPadding = customBodyPadding();
    <div
      class="vflex-000"
      [class.hpad-300]="!data.isBAM && !data.isSpotlight && !data.isPreview && !hasCustomPadding"
      [class.hpad-400]="data.isBAM && !data.isSpotlight && !data.isPreview && !hasCustomPadding"
      [class.fill-height]="data.isFullPage || data.isPreview"
      [class.has-header]="showHeader()"
    >
      @if (data.message) {
        <div class="dialog-message" [class.secondary]="data.messageIsSecondary">
          {{ data.message }}
        </div>
      } @else {
        @let maxHeight = contentMaxHeight();
        <div
          class="fill-height"
          [style.maxHeight]="maxHeight ? maxHeight + 'px' : null"
          [class.scrollable]="
            !data.isBAM && !data.isFullPage && !data.isSpotlight && !data.isPreview
          "
        >
          <ng-content></ng-content>
        </div>
      }
    </div>
  </div>
  @if (
    !data.isFullPage &&
    !data.isBAM &&
    !data.isPreview &&
    !hideFooter() &&
    (data.primaryButton || data.dangerButton || data.secondaryButton || data.tertiaryButton)
  ) {
    <mdw-dialog-footer
      [primaryButton]="primaryButtonName() || data.primaryButton"
      [primaryButtonIcon]="data.primaryButtonIcon"
      [dangerButton]="dangerButtonName() || data.dangerButton"
      [dangerButtonIcon]="data.dangerButtonIcon"
      [secondaryButton]="secondaryButtonName() || data.secondaryButton"
      [secondaryButtonIcon]="data.secondaryButtonIcon"
      [tertiaryButton]="tertiaryButtonName() || data.tertiaryButton"
      [tertiaryButtonIcon]="data.tertiaryButtonIcon"
      [primaryButtonDisabled]="primaryButtonDisabled()"
      [primaryButtonLoading]="primaryButtonLoading()"
      [dangerButtonDisabled]="dangerButtonDisabled()"
      [secondaryButtonDisabled]="secondaryButtonDisabled()"
      [tertiaryButtonDisabled]="tertiaryButtonDisabled()"
      (primaryButtonClicked)="customButtonHandlers() ? primaryButtonClicked.emit() : complete(true)"
      (dangerButtonClicked)="customButtonHandlers() ? dangerButtonClicked.emit() : complete(true)"
      (secondaryButtonClicked)="
        customButtonHandlers() ? secondaryButtonClicked.emit() : complete(false)
      "
      (tertiaryButtonClicked)="
        customButtonHandlers() ? tertiaryButtonClicked.emit() : complete(false)
      "
      [showSecondaryButton]="data.showSecondaryButton"
    ></mdw-dialog-footer>
  }
</div>
